/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import camelCaseKeys from 'camelcase-keys'
import snakeCaseKeys from 'snakecase-keys'

import { getCSRFToken } from '../lib/django'
import { getEnvs } from './env'

const { apiUrl } = getEnvs()

axios.interceptors.request.use(
  async (config) => {
    const csrfToken = await getCSRFToken()
    return {
      ...config,
      withCredentials: true,
      headers: {
        ...config.headers,
        ...(csrfToken ? { 'X-CSRFToken': csrfToken } : {}),
      },
    }
  },
  (error: AxiosError) => Promise.reject(error)
)

export const get = async <T>(
  url: string,
  options?: AxiosRequestConfig
): Promise<T> =>
  new Promise((resolve, reject) => {
    axios
      .get(`${apiUrl}${url}`, options)
      .then((res: AxiosResponse) => {
        resolve(camelCaseKeys(res.data, { deep: true }))
      })
      .catch((res: AxiosError) => {
        reject(res)
      })
  })

export const post = async <T>(
  url: string,
  payload: object,
  options?: AxiosRequestConfig,
  payloadIsNotAnObject?: boolean
): Promise<T> =>
  new Promise((resolve, reject) => {
    const p = payloadIsNotAnObject ? payload : snakeCaseKeys(payload)

    axios
      .post(`${apiUrl}${url}`, p, options)
      .then((res: AxiosResponse) => {
        resolve(camelCaseKeys(res.data, { deep: true }))
      })
      .catch((res: AxiosError) => {
        reject(res)
      })
  })

export const update = async <T>(
  url: string,
  payload: object,
  options?: AxiosRequestConfig,
  payloadIsNotAnObject?: boolean
): Promise<T> =>
  new Promise((resolve, reject) => {
    const p = payloadIsNotAnObject ? payload : snakeCaseKeys(payload)

    axios
      .patch(`${apiUrl}${url}`, p, options)
      .then((res: AxiosResponse) => {
        resolve(camelCaseKeys(res.data, { deep: true }))
      })
      .catch((res: AxiosError) => {
        reject(res)
      })
  })

export const del = async <T>(
  url: string,
  options?: AxiosRequestConfig
): Promise<T> =>
  new Promise((resolve, reject) => {
    axios
      .delete(`${apiUrl}${url}`, options)
      .then((res: AxiosResponse) => {
        resolve(camelCaseKeys(res.data, { deep: true }))
      })
      .catch((res: AxiosError) => {
        reject(res)
      })
  })
